import { FavoutitesItemComponent } from "widgets-module/components/favourites/favourites-item.component";
import { FavouritesStorage } from "widgets-module/components/favourites/favourites-storage.service";

export class FavouritesListControlService{

    private _storage: FavouritesStorage = null;
    private _currentContext: JQuery = null;
    private _items: Array<FavoutitesItemComponent> = [];

    private bindEvents(): void {
        this._items.forEach(item => {
            item.on(FavoutitesItemComponent.REMOVE_EVENT)
                .subscribe((x: FavoutitesItemComponent) => {
                    this._storage.remove(x.id);
                    x.destroy();
                });
        });
    }

    private parseContext(): void {
        const items = $(FavoutitesItemComponent.SELECTOR, this._currentContext);
        items.each((index, entry) => {
            const context = $(entry);
            const item = new FavoutitesItemComponent();
            item.init(context);
            this._items.push(item);
        });
    }

    public init(context: JQuery, cookieName: string, cookieSplitter: string): void {
        this._currentContext = context || this._currentContext;
        this._storage = new FavouritesStorage(cookieName, cookieSplitter);

        this.parseContext();
        this.bindEvents();
    }
}
